import * as React from "react";

import { Button } from "src/components/buttons";
import { DataTable, Page } from "src/components/common";
import AuthorizationWrapper from "src/common/AuthorizationWrapper";

import PickListContext from "src/context/pickListContext";
import OrganizationAPI from "src/admin/Organization/API/OrganizationAPI";
import {
	ClearFilterButton,
	ActionIcon,
} from "src/components/forms/ActionColumnIconsAndButton";
import { AdminPermissions } from "src/common/Permissions";
import { Tooltip } from "antd";

interface IProps {
	match?: any;
	history?: any;
}

interface IState {
	roles: RoleDTO[];
	organization: OrganizationDTO;
	filtered: any[];
	loading: boolean;
}

const defaultOgranization: OrganizationDTO = {
	name: "",
};

class OrganizationRole extends React.Component<IProps, IState> {
	public static contextType = PickListContext;
	public organizationId = this.props.match.params.organizationId;
	public state = {
		roles: [],
		organization: defaultOgranization,
		filtered: [],
		loading: false,
	};
	public _isMounted = true;
	public componentDidMount() {
		const organizationId = this.props.match.params.organizationId;
		this.setState({ loading: true });
		OrganizationAPI.getOrganizationRoles({ id: organizationId }).then((res) => {
			if (this._isMounted) {
				this.setState({ roles: res, loading: false });
			}
		});
		OrganizationAPI.getOrganization({ id: organizationId }).then((org) => {
			this.setState({ organization: org, loading: false });
		});
	}

	public componentWillUnmount() {
		this._isMounted = false;
	}

	public render() {
		const { organization } = this.state;
		const columns = this.getColumns();
		return (
			<Page title={organization.isDefault === true ? "Admin roles" : "Roles"}>
				<React.Fragment>
					<div className="container-fluid">
						<AuthorizationWrapper
							type="hide"
							permissions={[AdminPermissions.EditOrganizationRole]}
						>
							<div className="d-flex mb-4">
								<div className="ml-auto">
									<Button
										className="btn-primary"
										to={this.getActionLink(this.organizationId, -1)}
									>
										New Role
									</Button>
								</div>
							</div>
						</AuthorizationWrapper>
						<DataTable
							data={this.state.roles}
							columns={columns}
							filtered={this.state.filtered}
							onFilteredChange={(filtered: any) => this.setState({ filtered })}
							filterable={true}
							onRowClick={this.onRowClick}
							loading={this.state.loading}
						/>
					</div>
				</React.Fragment>
			</Page>
		);
	}

	private getActionLink = (orgId: any, rowId: any): string => {
		return `/admin/organizations/${orgId}/roles/${rowId}`;
	};

	private onRowClick = ({ row }: { row?: any }) => {
		this.props.history.push(this.getActionLink(this.organizationId, row.id));
	};

	private getColumns() {
		const columns = [
			{
				accessor: "id",
				show: false,
			},
			{
				Header: <Tooltip title="Role">Role</Tooltip>,
				accessor: "name",
				filterable: true,
			},
			{
				Header: <Tooltip title="Description">Description</Tooltip>,
				accessor: "description",
				filterable: true,
			},
			{
				Header: <Tooltip title="Role Type">Role Type</Tooltip>,
				accessor: "roleTypeId",
				filterable: true,
				filterMethod: this.picklistDescriptionFilter,
				Cell: this.picklistDescriptionCell("roleTypeId"),
			},
			{
				Header: <Tooltip title="Actions">Actions</Tooltip>,
				accessor: "Actions",
				Cell: <ActionIcon title="Details" type="open" />,
				Filter: (
					<ClearFilterButton onClick={() => this.setState({ filtered: [] })} />
				),
				id: "Actions",
			},
		];
		return columns;
	}
	private picklistDescriptionCell = (prop: string) => (rowInfo: any) => {
		if (rowInfo.row[prop] === undefined) {
			return "N/A";
		} else {
			return this.context.pickListItems && this.context.pickListItems.length > 0
				? this.context.pickListItems.find(
						(item: PickListItemResponseDTO) => item.id === rowInfo.row[prop]
				  )!.description
				: "Loading";
		}
	};
	private picklistDescriptionFilter = (filter: any, row: LocationDTO) => {
		if (row[filter.id] === undefined) {
			return false;
		} else {
			const picklistItemDescription = this.context.pickListItems.find(
				(item: PickListItemResponseDTO) => item.id === row[filter.id]
			)!.description!;
			return (
				picklistItemDescription
					.toLowerCase()
					.indexOf(filter.value.toLowerCase()) >= 0
			);
		}
	};
}

export default OrganizationRole;
